var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "window",
      attrs: { id: "settings", role: "tabpanel", "aria-label": "Settings" },
    },
    [
      _c("div", { staticClass: "header" }, [_c("SidebarToggle")], 1),
      _c(
        "form",
        {
          ref: "settingsForm",
          staticClass: "container",
          attrs: { autocomplete: "off" },
          on: {
            change: _vm.onChange,
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("h1", { staticClass: "title" }, [_vm._v("Settings")]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "advanced" },
                domProps: { checked: _vm.$store.state.settings.advanced },
              }),
              _vm._v("\n\t\t\t\t\tAdvanced settings\n\t\t\t\t"),
            ]),
          ]),
          _vm.canRegisterProtocol || _vm.hasInstallPromptEvent
            ? _c("div", [
                _c("h2", [_vm._v("Native app")]),
                _vm.hasInstallPromptEvent
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.nativeInstallPrompt.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\tAdd The Lounge to Home screen\n\t\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.canRegisterProtocol
                  ? _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.registerProtocol.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\tOpen irc:// URLs with The Lounge\n\t\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public &&
          _vm.$store.state.settings.advanced
            ? _c(
                "div",
                [
                  _c("h2", [_vm._v("Settings synchronisation")]),
                  _c("label", { staticClass: "opt" }, [
                    _c("input", {
                      attrs: { type: "checkbox", name: "syncSettings" },
                      domProps: {
                        checked: _vm.$store.state.settings.syncSettings,
                      },
                    }),
                    _vm._v(
                      "\n\t\t\t\t\tSynchronize settings with other clients\n\t\t\t\t"
                    ),
                  ]),
                  !_vm.$store.state.settings.syncSettings
                    ? [
                        _vm.$store.state.serverHasSettings
                          ? _c("div", { staticClass: "settings-sync-panel" }, [
                              _vm._m(0),
                              _c("p", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tUse the button below to enable synchronization, and override any\n\t\t\t\t\t\t\tsettings already synced to the server.\n\t\t\t\t\t\t"
                                ),
                              ]),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-small",
                                  attrs: { type: "button" },
                                  on: { click: _vm.onForceSyncClick },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\tSync settings and enable\n\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", { staticClass: "settings-sync-panel" }, [
                              _vm._m(1),
                            ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c("h2", [_vm._v("Messages")]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "motd" },
                domProps: { checked: _vm.$store.state.settings.motd },
              }),
              _vm._v("\n\t\t\t\t\tShow "),
              _c("abbr", { attrs: { title: "Message Of The Day" } }, [
                _vm._v("MOTD"),
              ]),
            ]),
          ]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "showSeconds" },
                domProps: { checked: _vm.$store.state.settings.showSeconds },
              }),
              _vm._v("\n\t\t\t\t\tInclude seconds in timestamp\n\t\t\t\t"),
            ]),
          ]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "use12hClock" },
                domProps: { checked: _vm.$store.state.settings.use12hClock },
              }),
              _vm._v("\n\t\t\t\t\tUse 12-hour timestamps\n\t\t\t\t"),
            ]),
          ]),
          !_vm.$store.state.serverConfiguration.public &&
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("h2", [_vm._v("Automatic away message")]),
                _c("label", { staticClass: "opt" }, [
                  _c(
                    "label",
                    { staticClass: "sr-only", attrs: { for: "awayMessage" } },
                    [_vm._v("Automatic away message")]
                  ),
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      id: "awayMessage",
                      type: "text",
                      name: "awayMessage",
                      placeholder: "Away message if The Lounge is not open",
                    },
                    domProps: { value: _vm.$store.state.settings.awayMessage },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._m(2),
          _c(
            "div",
            {
              attrs: {
                role: "group",
                "aria-labelledby": "label-status-messages",
              },
            },
            [
              _c("label", { staticClass: "opt" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "statusMessages",
                    value: "shown",
                  },
                  domProps: {
                    checked:
                      _vm.$store.state.settings.statusMessages === "shown",
                  },
                }),
                _vm._v(
                  "\n\t\t\t\t\tShow all status messages individually\n\t\t\t\t"
                ),
              ]),
              _c("label", { staticClass: "opt" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "statusMessages",
                    value: "condensed",
                  },
                  domProps: {
                    checked:
                      _vm.$store.state.settings.statusMessages === "condensed",
                  },
                }),
                _vm._v(
                  "\n\t\t\t\t\tCondense status messages together\n\t\t\t\t"
                ),
              ]),
              _c("label", { staticClass: "opt" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "statusMessages",
                    value: "hidden",
                  },
                  domProps: {
                    checked:
                      _vm.$store.state.settings.statusMessages === "hidden",
                  },
                }),
                _vm._v("\n\t\t\t\t\tHide all status messages\n\t\t\t\t"),
              ]),
            ]
          ),
          _c("h2", [_vm._v("Visual Aids")]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "coloredNicks" },
                domProps: { checked: _vm.$store.state.settings.coloredNicks },
              }),
              _vm._v("\n\t\t\t\t\tEnable colored nicknames\n\t\t\t\t"),
            ]),
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "autocomplete" },
                domProps: { checked: _vm.$store.state.settings.autocomplete },
              }),
              _vm._v("\n\t\t\t\t\tEnable autocomplete\n\t\t\t\t"),
            ]),
          ]),
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("label", { staticClass: "opt" }, [
                  _vm._m(3),
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      id: "nickPostfix",
                      type: "text",
                      name: "nickPostfix",
                      placeholder: "Nick autocomplete postfix (e.g. ', ')",
                    },
                    domProps: { value: _vm.$store.state.settings.nickPostfix },
                  }),
                ]),
              ])
            : _vm._e(),
          _c("h2", [_vm._v("Theme")]),
          _c("div", [
            _c(
              "label",
              { staticClass: "sr-only", attrs: { for: "theme-select" } },
              [_vm._v("Theme")]
            ),
            _c(
              "select",
              {
                staticClass: "input",
                attrs: { id: "theme-select", name: "theme" },
                domProps: { value: _vm.$store.state.settings.theme },
              },
              _vm._l(
                _vm.$store.state.serverConfiguration.themes,
                function (theme) {
                  return _c(
                    "option",
                    { key: theme.name, domProps: { value: theme.name } },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(theme.displayName) +
                          "\n\t\t\t\t\t"
                      ),
                    ]
                  )
                }
              ),
              0
            ),
          ]),
          _vm.$store.state.serverConfiguration.prefetch
            ? [
                _c("h2", [_vm._v("Link previews")]),
                _c("div", [
                  _c("label", { staticClass: "opt" }, [
                    _c("input", {
                      attrs: { type: "checkbox", name: "media" },
                      domProps: { checked: _vm.$store.state.settings.media },
                    }),
                    _vm._v("\n\t\t\t\t\t\tAuto-expand media\n\t\t\t\t\t"),
                  ]),
                ]),
                _c("div", [
                  _c("label", { staticClass: "opt" }, [
                    _c("input", {
                      attrs: { type: "checkbox", name: "links" },
                      domProps: { checked: _vm.$store.state.settings.links },
                    }),
                    _vm._v("\n\t\t\t\t\t\tAuto-expand websites\n\t\t\t\t\t"),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm.$store.state.settings.advanced &&
          _vm.$store.state.serverConfiguration.fileUpload
            ? _c("div", [
                _c("h2", [_vm._v("File uploads")]),
                _c("div", [
                  _c("label", { staticClass: "opt" }, [
                    _c("input", {
                      attrs: { type: "checkbox", name: "uploadCanvas" },
                      domProps: {
                        checked: _vm.$store.state.settings.uploadCanvas,
                      },
                    }),
                    _vm._v(
                      "\n\t\t\t\t\t\tAttempt to remove metadata from images before uploading\n\t\t\t\t\t\t"
                    ),
                    _vm._m(4),
                  ]),
                ]),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public
            ? [
                _c("h2", [_vm._v("Push Notifications")]),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      attrs: {
                        id: "pushNotifications",
                        type: "button",
                        disabled:
                          _vm.$store.state.pushNotificationState !==
                            "supported" &&
                          _vm.$store.state.pushNotificationState !==
                            "subscribed",
                      },
                      on: { click: _vm.onPushButtonClick },
                    },
                    [
                      _vm.$store.state.pushNotificationState === "subscribed"
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tUnsubscribe from push notifications\n\t\t\t\t\t\t"
                            ),
                          ]
                        : _vm.$store.state.pushNotificationState === "loading"
                        ? [_vm._v("\n\t\t\t\t\t\t\tLoading…\n\t\t\t\t\t\t")]
                        : [_vm._v(" Subscribe to push notifications ")],
                    ],
                    2
                  ),
                  _vm.$store.state.pushNotificationState === "nohttps"
                    ? _c("div", { staticClass: "error" }, [
                        _c("strong", [_vm._v("Warning")]),
                        _vm._v(
                          ": Push notifications are only supported over HTTPS\n\t\t\t\t\t\tconnections.\n\t\t\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                  _vm.$store.state.pushNotificationState === "unsupported"
                    ? _c("div", { staticClass: "error" }, [
                        _c("strong", [_vm._v("Warning")]),
                        _vm._v(":\n\t\t\t\t\t\t"),
                        _c("span", [
                          _vm._v(
                            "Push notifications are not supported by your browser."
                          ),
                        ]),
                        _vm.isIOS
                          ? _c(
                              "div",
                              { staticClass: "apple-push-unsupported" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tSafari does\n\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://bugs.webkit.org/show_bug.cgi?id=182566",
                                      target: "_blank",
                                      rel: "noopener",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "not support the web push notification specification"
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  ", and because all browsers on iOS use Safari under the hood, The Lounge\n\t\t\t\t\t\t\tis unable to provide push notifications on iOS devices.\n\t\t\t\t\t\t"
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]
            : _vm._e(),
          _c("h2", [_vm._v("Browser Notifications")]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: {
                  id: "desktopNotifications",
                  disabled:
                    _vm.$store.state.desktopNotificationState === "nohttps",
                  type: "checkbox",
                  name: "desktopNotifications",
                },
                domProps: {
                  checked: _vm.$store.state.settings.desktopNotifications,
                },
              }),
              _vm._v("\n\t\t\t\t\tEnable browser notifications"),
              _c("br"),
              _vm.$store.state.desktopNotificationState === "unsupported"
                ? _c("div", { staticClass: "error" }, [
                    _c("strong", [_vm._v("Warning")]),
                    _vm._v(
                      ": Notifications are not supported by your browser.\n\t\t\t\t\t"
                    ),
                  ])
                : _vm._e(),
              _vm.$store.state.desktopNotificationState === "nohttps"
                ? _c(
                    "div",
                    {
                      staticClass: "error",
                      attrs: { id: "warnBlockedDesktopNotifications" },
                    },
                    [
                      _c("strong", [_vm._v("Warning")]),
                      _vm._v(
                        ": Notifications are only supported over HTTPS\n\t\t\t\t\t\tconnections.\n\t\t\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.$store.state.desktopNotificationState === "blocked"
                ? _c(
                    "div",
                    {
                      staticClass: "error",
                      attrs: { id: "warnBlockedDesktopNotifications" },
                    },
                    [
                      _c("strong", [_vm._v("Warning")]),
                      _vm._v(
                        ": Notifications are blocked by your browser.\n\t\t\t\t\t"
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("div", [
            _c("label", { staticClass: "opt" }, [
              _c("input", {
                attrs: { type: "checkbox", name: "notification" },
                domProps: { checked: _vm.$store.state.settings.notification },
              }),
              _vm._v("\n\t\t\t\t\tEnable notification sound\n\t\t\t\t"),
            ]),
          ]),
          _c("div", [
            _c("div", { staticClass: "opt" }, [
              _c(
                "button",
                {
                  attrs: { id: "play" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.playNotification.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Play sound")]
              ),
            ]),
          ]),
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("label", { staticClass: "opt" }, [
                  _c("input", {
                    attrs: { type: "checkbox", name: "notifyAllMessages" },
                    domProps: {
                      checked: _vm.$store.state.settings.notifyAllMessages,
                    },
                  }),
                  _vm._v(
                    "\n\t\t\t\t\tEnable notification for all messages\n\t\t\t\t"
                  ),
                ]),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public &&
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("label", { staticClass: "opt" }, [
                  _vm._m(5),
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      id: "highlights",
                      type: "text",
                      name: "highlights",
                      autocomplete: "off",
                      placeholder:
                        "Comma-separated, e.g.: word, some more words, anotherword",
                    },
                    domProps: { value: _vm.$store.state.settings.highlights },
                  }),
                ]),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public &&
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("label", { staticClass: "opt" }, [
                  _vm._m(6),
                  _c("input", {
                    staticClass: "input",
                    attrs: {
                      id: "highlightExceptions",
                      type: "text",
                      name: "highlightExceptions",
                      autocomplete: "off",
                      placeholder:
                        "Comma-separated, e.g.: word, some more words, anotherword",
                    },
                    domProps: {
                      value: _vm.$store.state.settings.highlightExceptions,
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public &&
          !_vm.$store.state.serverConfiguration.ldapEnabled
            ? _c(
                "div",
                {
                  attrs: {
                    id: "change-password",
                    role: "group",
                    "aria-labelledby": "label-change-password",
                  },
                },
                [
                  _c("h2", { attrs: { id: "label-change-password" } }, [
                    _vm._v("Change password"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "password-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "sr-only",
                          attrs: { for: "current-password" },
                        },
                        [_vm._v(" Enter current password ")]
                      ),
                      _c("RevealPassword", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (slotProps) {
                                return [
                                  _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      id: "current-password",
                                      autocomplete: "current-password",
                                      type: slotProps.isVisible
                                        ? "text"
                                        : "password",
                                      name: "old_password",
                                      placeholder: "Enter current password",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3685841584
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "password-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "sr-only",
                          attrs: { for: "new-password" },
                        },
                        [_vm._v(" Enter desired new password ")]
                      ),
                      _c("RevealPassword", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (slotProps) {
                                return [
                                  _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      id: "new-password",
                                      type: slotProps.isVisible
                                        ? "text"
                                        : "password",
                                      name: "new_password",
                                      autocomplete: "new-password",
                                      placeholder: "Enter desired new password",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2370278294
                        ),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "password-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "sr-only",
                          attrs: { for: "new-password-verify" },
                        },
                        [_vm._v(" Repeat new password ")]
                      ),
                      _c("RevealPassword", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (slotProps) {
                                return [
                                  _c("input", {
                                    staticClass: "input",
                                    attrs: {
                                      id: "new-password-verify",
                                      type: slotProps.isVisible
                                        ? "text"
                                        : "password",
                                      name: "verify_password",
                                      autocomplete: "new-password",
                                      placeholder: "Repeat new password",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1162600176
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm.passwordChangeStatus && _vm.passwordChangeStatus.success
                    ? _c("div", { staticClass: "feedback success" }, [
                        _vm._v(
                          "\n\t\t\t\t\tSuccessfully updated your password\n\t\t\t\t"
                        ),
                      ])
                    : _vm.passwordChangeStatus && _vm.passwordChangeStatus.error
                    ? _c("div", { staticClass: "feedback error" }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.passwordErrors[_vm.passwordChangeStatus.error]
                            ) +
                            "\n\t\t\t\t"
                        ),
                      ])
                    : _vm._e(),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        attrs: { type: "submit" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.changePassword.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t\tChange password\n\t\t\t\t\t")]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm.$store.state.settings.advanced
            ? _c("div", [
                _c("h2", [_vm._v("Custom Stylesheet")]),
                _c(
                  "label",
                  {
                    staticClass: "sr-only",
                    attrs: { for: "user-specified-css-input" },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\tCustom stylesheet. You can override any style with CSS here.\n\t\t\t\t"
                    ),
                  ]
                ),
                _c("textarea", {
                  staticClass: "input",
                  attrs: {
                    id: "user-specified-css-input",
                    name: "userStyles",
                    placeholder:
                      "/* You can override any style with CSS here */",
                  },
                  domProps: { value: _vm.$store.state.settings.userStyles },
                }),
              ])
            : _vm._e(),
          !_vm.$store.state.serverConfiguration.public
            ? _c(
                "div",
                { staticClass: "session-list", attrs: { role: "group" } },
                [
                  _c("h2", [_vm._v("Sessions")]),
                  _c("h3", [_vm._v("Current session")]),
                  _vm.currentSession
                    ? _c("Session", { attrs: { session: _vm.currentSession } })
                    : _vm._e(),
                  _vm.activeSessions.length > 0
                    ? [
                        _c("h3", [_vm._v("Active sessions")]),
                        _vm._l(_vm.activeSessions, function (session) {
                          return _c("Session", {
                            key: session.token,
                            attrs: { session: session },
                          })
                        }),
                      ]
                    : _vm._e(),
                  _c("h3", [_vm._v("Other sessions")]),
                  _vm.$store.state.sessions.length === 0
                    ? _c("p", [_vm._v("Loading…")])
                    : _vm.otherSessions.length === 0
                    ? _c("p", [
                        _c("em", [
                          _vm._v(
                            "You are not currently logged in to any other device."
                          ),
                        ]),
                      ])
                    : _vm._l(_vm.otherSessions, function (session) {
                        return _c("Session", {
                          key: session.token,
                          attrs: { session: session },
                        })
                      }),
                ],
                2
              )
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Warning:")]),
      _vm._v(
        " Checking this box will override the settings\n\t\t\t\t\t\t\tof this client with those stored on the server.\n\t\t\t\t\t\t"
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Warning:")]),
      _vm._v(
        " No settings have been synced before. Enabling\n\t\t\t\t\t\t\tthis will sync all settings of this client as the base for other\n\t\t\t\t\t\t\tclients.\n\t\t\t\t\t\t"
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { attrs: { id: "label-status-messages" } }, [
      _vm._v("\n\t\t\t\tStatus messages\n\t\t\t\t"),
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-n tooltipped-no-delay",
          attrs: {
            "aria-label":
              "Joins, parts, quits, kicks, nick changes, and mode changes",
          },
        },
        [_c("button", { staticClass: "extra-help" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "opt", attrs: { for: "nickPostfix" } }, [
      _vm._v("\n\t\t\t\t\t\tNick autocomplete postfix\n\t\t\t\t\t\t"),
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-n tooltipped-no-delay",
          attrs: {
            "aria-label": "Nick autocomplete postfix (for example a comma)",
          },
        },
        [_c("button", { staticClass: "extra-help" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "tooltipped tooltipped-n tooltipped-no-delay",
        attrs: {
          "aria-label":
            "This option renders the image into a canvas element to remove metadata from the image.\nThis may break orientation if your browser does not support that.",
        },
      },
      [_c("button", { staticClass: "extra-help" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "opt", attrs: { for: "highlights" } }, [
      _vm._v("\n\t\t\t\t\t\tCustom highlights\n\t\t\t\t\t\t"),
      _c(
        "span",
        {
          staticClass: "tooltipped tooltipped-n tooltipped-no-delay",
          attrs: {
            "aria-label":
              "If a message contains any of these comma-separated \nexpressions, it will trigger a highlight.",
          },
        },
        [_c("button", { staticClass: "extra-help" })]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "opt", attrs: { for: "highlightExceptions" } },
      [
        _vm._v("\n\t\t\t\t\t\tHighlight exceptions\n\t\t\t\t\t\t"),
        _c(
          "span",
          {
            staticClass: "tooltipped tooltipped-n tooltipped-no-delay",
            attrs: {
              "aria-label":
                "If a message contains any of these comma-separated \nexpressions, it will not trigger a highlight even if it contains \nyour nickname or expressions defined in custom highlights.",
            },
          },
          [_c("button", { staticClass: "extra-help" })]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }